import { useAtomValue, useSetAtom } from 'jotai'
import {
  lastSaveWorkDateAtom,
  workSaveRetryNonceAtom,
  workSaveStatusAtom,
} from '../../store/saveWorkAtoms'
import { Check, RotateCcw, TriangleAlert, WifiOff } from 'lucide-react'
import { useTar } from '@/modules/i18n'
import { useLocalSettings } from '@/hooks/useLocalSettings'
import { RelativeDateTime } from '@components/datetime'

export const LastWorkSave = () => {
  const { t } = useTar()
  const lastSaveDate = useAtomValue(lastSaveWorkDateAtom)
  const saveStatus = useAtomValue(workSaveStatusAtom)
  const setSaveStatus = useSetAtom(workSaveStatusAtom)
  const bumpRetry = useSetAtom(workSaveRetryNonceAtom)
  const { getSetting } = useLocalSettings()

  if (getSetting('autosaveIndicator') === false) return null

  const handleRetry = () => {
    setSaveStatus('saving')
    bumpRetry((n) => n + 1)
  }

  const isFailed = saveStatus === 'offline' || saveStatus === 'error'

  return (
    <div className="hidden lg:flex flex-col justify-center gap-1.5 ps-3 md:ps-4 md:pe-2">
      <span className="text-[10px] font-medium uppercase tracking-wider text-muted-foreground leading-none">
        {t('common.autosave')}
      </span>
      {isFailed ? (
        <span className="flex items-center gap-1.5 text-sm font-medium text-destructive leading-none">
          {saveStatus === 'offline' ? (
            <>
              <WifiOff className="size-3.5" strokeWidth={3} />
              {t('common.offline')}
            </>
          ) : (
            <>
              <TriangleAlert className="size-3.5" strokeWidth={3} />
              {t('common.saveFailed')}
            </>
          )}
          <button
            type="button"
            onClick={handleRetry}
            aria-label={t('common.retrySave')}
            title={t('common.retrySave')}
            className="ms-0.5 rounded-sm p-0.5 hover:bg-destructive/10 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-destructive"
          >
            <RotateCcw className="size-3.5" strokeWidth={3} />
          </button>
        </span>
      ) : (
        <span className="flex items-center gap-1 text-sm font-medium text-primary leading-none">
          <Check className="size-3.5" strokeWidth={3} />
          <RelativeDateTime isoDateString={lastSaveDate.toISOString()} calm />
        </span>
      )}
    </div>
  )
}
